























































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

import DocumentSignature from "@/employee/components/DocumentSignature.vue";
import WizardNavigation from "@/employee/components/investments/drivewealth/wizard/WizardNavigation.vue";
import { DrivewealthWizardStep, DrivewealthAccountManagementType } from "@/shared/types";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";
import { useDrivewealthStore } from "@/shared/store/drivewealth";
import { useRiskToleranceQuestionnaireStore } from "@/shared/store/riskToleranceQuestionnaire";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as RouteNames from "@/employee/route-names";

@Component ({
  components: {
    DocumentSignature,
    WizardNavigation,
    GenericLoadingSpinner
  }
})
export default class CustomerSignature extends Vue {
  @Prop({required: false})
  isPreenrollment: boolean;

  @Prop({required: false})
  isCreatingAccount: boolean;

  @Prop({required: false})
  isSavingAccountClaims: boolean;

  @Prop({required: false})
  accountId: number;

  @Prop({required: false})
  documentKey: string;

  @Prop({required: false})
  isWizard: boolean;

  @Prop({required: false})
  redirectRouteName: string;

  @Prop({required: false})
  enableCheckbox: boolean;

  isSigned = false;
  signatureData: {} = {};
  isSubmitting = false;

  featureFlagStore = useFeatureFlagStore();
  drivewealthWizardStore = useDrivewealthWizardStore();
  drivewealthStore = useDrivewealthStore();
  riskToleranceQuestionnaireStore = useRiskToleranceQuestionnaireStore();
  custodianSettingsStore = useCustodianSettingsStore();

  mounted (): void {
    if (!this.documentKey) {
      this.drivewealthStore.loadUserAgreementDocumentKey(this.drivewealthWizardStore.accountType);
    }
    this.drivewealthWizardStore.loadDividendReinvestmentDisclosures({});
    this.drivewealthWizardStore.loadBalanceAndIsAllowedToPreenroll({});
    this.signatureData[drivewealth.InvestmentSignatureAttrName] = this.drivewealthWizardStore.accountType;
  }

  get wizardStep (): DrivewealthWizardStep {
    return DrivewealthWizardStep.CustomerSignature;
  }

  get isLoaded (): boolean {
    return !(this.documentKey === null || this.documentKey === "" || this.documentKey === undefined)
    || this.drivewealthStore.isUserAgreementDocumentKeyLoaded;
  }

  get showLoading (): boolean {
    return this.disclosureDocumentKey === null;
  }

  get disclosureDocumentKey (): string {
    if (this.documentKey) {
      return this.documentKey;
    }

    if (this.isLoaded) {
        return this.drivewealthStore.getUserAgreementDocumentKey !== null
        ? this.drivewealthStore.getUserAgreementDocumentKey
        : drivewealth.advisoryDocumentKeyMap[this.drivewealthWizardStore.accountType];
    }
    return null;
  }

  tryAdvance (): void {
    this.createAccount();
  }

  get createAction () {

    if (this.drivewealthWizardStore.drivewealthAccountManagementType === DrivewealthAccountManagementType.Advisory &&
      this.riskToleranceQuestionnaireStore.userRtqEligibilityResponse &&
      this.riskToleranceQuestionnaireStore.userRtqEligibilityResponse.curatedRtqEnabledByEmployerOrPartner) {
        return () => Promise.resolve();
    }

    if (this.drivewealthWizardStore.drivewealthAccountManagementType === DrivewealthAccountManagementType.RiaManaged &&
      this.custodianSettingsStore.isHsaBankCustodian) {
      return () => Promise.resolve();
    }

    if (this.isCreatingAccount) { return this.drivewealthWizardStore.createCustomerAccount; }
    if (this.isPreenrollment) { return this.drivewealthWizardStore.preenrollCustomer; }
    if (this.isSavingAccountClaims) { return this.drivewealthWizardStore.claimAccount; }

    return () => Promise.reject();
  }

  createAccount (): void {
    if (this.isSubmitting) { return; }

    this.isSubmitting = true;
    this.$emit("submitting", true);

    this.createAction(this.accountId)
      .then(() => {
         this.drivewealthWizardStore.setWizardStepComplete(DrivewealthWizardStep.CustomerSignature);
      })
      .finally(() => {
        this.isSubmitting = false;
        this.$emit("submitting", false);
      });
  }

  onSigned (val): void {
    if (val === null) {
      return;
    }
    if (val.length > 0) {
      this.isSigned = true;
      this.drivewealthWizardStore.setSignatureContent(val);
    } else {
      this.isSigned = false;
    }
  }

  onRedirectClick (): void {
    const params: any = {};

    if (this.accountId) {
      params.accountId = this.accountId;
    }

    this.$router.push({
      name: this.redirectRouteName,
      params
    });
  }
}
